import{c as e}from"./vue-class-component.esm-bundler.js";function Ref(t){return e(((e,c)=>{e.computed=e.computed||{},e.computed[c]={cache:!1,get:function(){return this.$refs[t||c]}}}))}export{Ref as R};
//# sourceMappingURL=decorators.js.map
